import { IEltDocCompany } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltDocCompany'
import { IEltDocFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { TUpdateELTFormData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/common'
import { TMergedImages } from 'legacy/lut/components/widgets/public/partner360/ELT/models/ImageUpload'
import { CompanyImageUploader } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/companyImageUploader/CompanyImageUploader'
import { useCallback } from 'react'

import { Flex } from 'core-components/library/flex'
import { Textarea } from 'core-components/library/inputs'

import styles from './CompanyProfile.module.scss'

interface ICompanyProps {
  formData: IEltDocFormData
  onChangeComplexFormData: (data: IEltDocCompany) => void
  onImageUpload: (fieldName: string, file: any, fileName: string) => void
  updateData: TUpdateELTFormData
  formIsFinalized: boolean
  displayedImages: TMergedImages
}

export const CompanyProfile = ({
  formData,
  onChangeComplexFormData,
  onImageUpload,
  updateData,
  formIsFinalized,

  displayedImages,
}: ICompanyProps) => {
  const changeCompanyName = useCallback(
    (value: string) => {
      onChangeComplexFormData({ ...formData.Company, CompanyProfile: value })
    },
    [formData.Company, onChangeComplexFormData]
  )

  return (
    <Flex className={styles.content} alignItems={'flex-end'}>
      <CompanyImageUploader
        onImageUpload={onImageUpload}
        updateData={updateData}
        formIsFinalized={formIsFinalized}
        onlyLogo
        titleVariant={'dark'}
        displayedImages={displayedImages}
      />
      <Textarea
        classes={{
          root: styles.input,
        }}
        value={formData.Company?.CompanyProfile || ''}
        onChange={changeCompanyName}
      />
    </Flex>
  )
}
